import React, { useEffect, useState } from 'react';
import UserRoundIcon from '../../../atoms/icons/user-round-icon';
import {
  CloseIcon,
  TelevisionClassicIcon,
  CellPhoneIcon,
  HeartIcon,
  LifeBuoyIcon,
  InformationOutlineIcon,
  CellphoneDownloadIcon,
  BinocularsIcon,
  BookmarkIcon,
} from '../../../atoms/material-icons';
import { connect, useSelector, useDispatch } from 'react-redux';
import SvgIcon from '../../../atoms/svg-icon';
import './mega-menu.m.css';
import { BQLink } from '../../../atoms/bqlink';
import { CONTACT, SOCIAL_SHARE, PATH } from '../../../../constants';
import get from 'lodash/get';
import menuIcons from '../../../atoms/material-icons/icon-mapping';
import AngleDown from '../../../atoms/icons/angle-down';
import Icon from '@mdi/react';
import {
  mdiAccountCircle,
  mdiBookmark,
  mdiReceiptText,
  mdiSackPercent,
  mdiStarFourPoints,
  mdiHome,
  mdiWeb,
  mdiBinoculars,
} from '@mdi/js';
import LogoutIcon from '../../../atoms/icons/logout';
import {
  getSSOLogoutUrl,
  getSSOLoginUrl,
  getSSORedirectUrl,
} from '../../../../helpers/subscription-helper';
import { clearSSOUserDetails, getUserInitials, getUserStatus } from '../../../../helpers/utils';

import Premium from '../../../atoms/logo/premium';
import {
  accountInteraction,
  clickPreferredSourceBadge,
  downloadAppDl,
  languageSelection,
  signInClick,
  watchLiveInteraction,
} from '../../../../helpers/datalayer-utils';
import { followIconsDl } from '../../../../helpers/datalayer-utils';

const mobileMenu = [
  {
    id: 1,
    name: 'Profile',
    icon: mdiAccountCircle,
    link: '/my-account/profile?src=menu_user',
  },
  {
    id: 2,
    name: 'My Subscription',
    icon: mdiReceiptText,
    link: '/my-account/subscription?src=menu_subscribe',
  },
  {
    id: 3,
    name: 'Watchlist',
    icon: mdiBinoculars,
    link: '/my-account/watchlist?src=menu_watchlist',
  },
  {
    id: 4,
    name: 'Bookmarks',
    icon: mdiBookmark,
    link: '/my-account/bookmarks?src=menu_bookmarks',
  },
];

const MegaMenu = ({
  showMenu,
  userDetails,
  handleMenuClose,
  menu,
  isSubscriber,
  integrations,
  showMenuBar,
  clientHost,
  isBeeps = false,
}) => {
  const dispatch = useDispatch();
  const [currentOpenMenu, setCurrentOpenMenu] = useState('');
  const [isLoading, setLoading] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isUpperSize, setUpperSize] = useState(true);
  const [appDownloadLink, setAppDownloadLink] = useState('');
  const [scrollY, setScrollY] = useState(0);
  const [isHomePage, setHomePage] = useState(false);
  const [isPodcast, setPodcast] = useState(false);
  const [showApp, setShowApp] = useState(false);
  const [isProfile, setProfile] = useState(true);
  useEffect(() => {
    if (userDetails !== undefined) setProfile(false);
  }, [userDetails]);

  const getPageTypeFromUrl = () => {
    if (typeof window === 'undefined') return 'unknown-page-type';
    const path = window.location.pathname;
    if (path === '/') {
      return 'home-page';
    }
    const pathParts = path.replace(/^\/|\/$/g, '').split('/');
    if (pathParts?.length === 1) {
      return 'section-page';
    } else if (pathParts?.length >= 2) {
      return 'story-page';
    }
    return 'unknown-page-type';
  };

  const pageType = getPageTypeFromUrl();
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem('pageTypeValue', pageType);
  }
  const formattedPageType =
    pageType === 'story-page' ? 'story' : pageType === 'home-page' ? 'home-page' : 'section-page';
  const SSO_LOGIN_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'login_url'], null),
  );
  const SSO_LOGOUT_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'logout_url'], null),
  );
  const worldsummit = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'worldsummit'], {}),
  );
  const googleBadge = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'google_badge_content'], {}),
  );
  const [redirectUrl, setRedirectUrl] = useState('');
  const [loginUrl, setLoginUrl] = useState('');
  const [isOpen, setOpen] = useState(false);
  const userDataFromRedux = useSelector((state) => get(state, ['userData']));
  const userData = isBeeps ? userDetails : userDataFromRedux;
  const [bookmarkUrl, setBookmarkUrl] = useState(clientHost);
  const [watchlistUrl, setWatchlistUrl] = useState(clientHost);
  const handleMenuExpand = (menuName) => {
    if (currentOpenMenu === menuName) {
      setCurrentOpenMenu('');
    } else {
      setCurrentOpenMenu(menuName);
    }
  };

  const handleClick = () => {
    const width = window.innerWidth;
    if (width <= 767) {
      setOpen(!isOpen);
    } else {
      setOpen(false);
      window.location.href = '/my-account/profile?src=menu_user';
    }
  };
  const handleClickItem = (menu, formattedPageType) => {
    const baseData = {
      event: 'navigation_interaction',
      cta_text: 'NA',
      select_type: 'hamburger',
      page_template: formattedPageType || 'NA',
      user_id: userData?.userProfile?.userId || 'NA',
      user_status: getUserStatus(),
      login_type: userData?.isLoggedIn ? 'logged-in' : 'logged-out',
      language_hit: 'english',
      Platform: isMobile ? 'mobile' : 'desktop',
      SiteName: 'www.ndtvprofit.com',
    };

    if (menu?.completeUrl === '/premium') {
      baseData.cta_text = 'premium';
    } else if (menu?.title.toLowerCase() === 'beeps') {
      baseData.cta_text = 'beeps';
    } else if (menu?.completeUrl === '/budget') {
      baseData.cta_text = 'budget';
    } else if (typeof menu === 'string') {
      baseData.cta_text = menu;
    } else if (menu && menu.title) {
      baseData.cta_text = menu?.title;
    } else {
      baseData.cta_text = 'NA';
    }

    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push(baseData);
    } else {
      console.error('Error: window.dataLayer is not available');
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      const storedData = localStorage.getItem('dataLayerSideMainMenuClick');

      if (storedData) {
        try {
          const dataLayerData = JSON.parse(storedData);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(dataLayerData);
          localStorage.removeItem('dataLayerSideMainMenuClick');
        } catch (error) {
          console.error('Error parsing stored data:', error);
        }
      }
    }
  }, [menu?.completeUrl]);

  useEffect(() => {
    if (!showMenu) {
      setCurrentOpenMenu('');
    }
    const path = window.location.pathname;
    const podcast = `/podcasts/all-you-need-to-know/${integrations?.podcast?.PODCAST_ID}`;
    const isPodcast = path === podcast || new RegExp(`^${podcast}/\\d+$`).test(path);
    setPodcast(isPodcast);
    const isHomePage = path === '/' || isPodcast;
    setHomePage(isHomePage);
  }, [showMenu]);

  useEffect(() => {
    const url = new URL(window?.location?.href);
    getSSORedirectUrl(url).then((pageUrl) => {
      setRedirectUrl(pageUrl);
    });
    const userAgent = window.navigator.userAgent;

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      setAppDownloadLink('https://apps.apple.com/in/app/ndtv-profit/id502359431');
    } else if (/Android/i.test(userAgent)) {
      setAppDownloadLink(
        'https://play.google.com/store/apps/details?id=com.ndtv.ndtvprofit&pcampaignid=web_share',
      );
    } else {
      setAppDownloadLink('/');
    }
    setScrollY(window.scrollY);
    setLoading(false);
  }, []);
  useEffect(() => {
    getSSOLoginUrl(
      integrations?.sso?.client_id,
      integrations?.sso?.client_secret,
      redirectUrl,
      SSO_LOGIN_URL,
    ).then((pageUrl) => {
      setLoginUrl(pageUrl);
      const bUrl = !!userDetails
        ? PATH.MYBQ_PAGE + PATH.MYACCOUNT_BOOKMARKS
        : pageUrl.replace(
            pageUrl.substring(pageUrl.indexOf('redirectUrl'), pageUrl?.length),
            `redirectUrl=${clientHost}${PATH.MYBQ_PAGE}${PATH.MYACCOUNT_BOOKMARKS}`,
          );
      setBookmarkUrl(bUrl);
      const wUrl = !!userDetails
        ? PATH.MYBQ_PAGE + PATH.MYACCOUNT_WATCHLIST
        : pageUrl.replace(
            pageUrl.substring(pageUrl.indexOf('redirectUrl'), pageUrl?.length),
            `redirectUrl=${clientHost}${PATH.MYBQ_PAGE}${PATH.MYACCOUNT_WATCHLIST}`,
          );
      setWatchlistUrl(wUrl);
    });
  }, [redirectUrl, userDetails]);

  useEffect(() => {
    const footerElement = document.getElementById('footer');
    if (footerElement) {
      const windowHeight = window.innerHeight;
      const footerRect = footerElement.getBoundingClientRect();
      const footerPosition = windowHeight * 0.8;
      setShowApp(footerRect.top > footerPosition);
    }
  }, [scrollY]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > scrollY && !isCollapsed) {
        setTimeout(() => {
          setIsCollapsed(true);
        }, 1000);
      }
      if (currentScrollY < scrollY && isCollapsed && isUpperSize) {
        setIsCollapsed(false);
        setTimeout(() => {
          setIsCollapsed(true);
        }, 1500);
        setUpperSize(false);
      }
      setScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollY, isCollapsed]);

  const onLogout = async () => {
    window.location = await getSSOLogoutUrl(
      integrations?.sso?.client_id,
      integrations?.sso?.client_secret,
      getSSORedirectUrl(new URL(window?.location?.href)),
      SSO_LOGOUT_URL,
    );
    await clearSSOUserDetails(dispatch);
  };
  const isUser = !isProfile && userDetails && typeof userDetails.fullName === 'string';
  const LoginForm = (className) => {
    return (
      <div
        styleName={isBeeps ? 'user-greet-section dark-user' : 'user-greet-section'}
        className={className}
      >
        <div styleName="greeting">
          <div styleName="user-initials">
            <div styleName={isUser ? 'inner-circle user-name' : 'inner-circle'}>
              {!isProfile && isUser ? (
                <div styleName="initials">{getUserInitials(userDetails) || 'R'}</div>
              ) : (
                <UserRoundIcon
                  color={'iron-color-40'}
                  fontSize="28px"
                  styleName="user-icon-default"
                />
              )}
            </div>
          </div>
          <div styleName="name-ctx">
            {!isProfile && userDetails && userDetails.userId ? (
              <div onClick={() => handleClick()} styleName="profile-wrap">
                <div styleName={isBeeps ? 'name dark-name' : 'name'}>
                  {userDetails.fullName || getUserInitials(userDetails) || 'Profit Reader'}&nbsp;
                  <img
                    styleName={`right-icon ${
                      (userDetails.fullName || userDetails.email) && !isOpen
                        ? 'rotated-down'
                        : (userDetails.fullName || userDetails.email) && isOpen
                          ? 'rotated-up'
                          : ''
                    }`}
                    src={
                      isBeeps
                        ? '/icons/ic_chevron_right_white_24px.svg'
                        : '/icons/ic_chevron_right.svg'
                    }
                    alt="Right icon"
                    loading="lazy"
                  />
                </div>
                <div styleName="tag-wrap">
                  <div styleName={`sub-tag ${isSubscriber ? 'premium-tag' : 'basic-tag'}`}>
                    {isSubscriber ? <span>✦ MEMBER</span> : <span>BASIC</span>}
                  </div>
                </div>
              </div>
            ) : (
              <React.Fragment>
                <div styleName={`name default-name ${isBeeps ? 'dark-name' : ''}`}>
                  Hello Reader
                </div>
                {!isBeeps && (
                  <div
                    onClick={() =>
                      signInClick(userData, pageType, 'Sign In / Register', 'hamburger')
                    }
                  >
                    <BQLink href={loginUrl} target="_self">
                      <div styleName={`sign-in ${isBeeps ? 'dark-sing-in' : ''}`}>
                        Sign In / Register&nbsp;
                        <img
                          styleName="right-icon"
                          src="/icons/ic_chevron_right.svg"
                          alt="Right icon"
                          loading="lazy"
                        />
                      </div>
                    </BQLink>
                  </div>
                )}
              </React.Fragment>
            )}
            <div></div>
            <div></div>
          </div>
        </div>
        {!!userDetails && !isBeeps && (
          <div
            styleName="logout-button"
            onClick={() => {
              accountInteraction(userData, formattedPageType, 'hamburger', 'logout');
              onLogout();
            }}
            className="desktop-only"
          >
            <span>
              <div styleName="icon">
                <LogoutIcon color="border6-color" />
              </div>
              Logout
            </span>
          </div>
        )}
        <div onClick={() => watchLiveInteraction(userData, formattedPageType, 'hamburger')}>
          <BQLink
            href="/live-tv?src=menu_livetv"
            styleName="live-tv-button"
            className="desktop-only"
          >
            <TelevisionClassicIcon color="#ffff" size="19px" />
            <span>LIVE TV</span>
          </BQLink>
        </div>
      </div>
    );
  };

  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleLanguageClick = (language, selectType) => {
    const baseData = {
      event: 'language_selection',
      page_template: formattedPageType,
      user_id: userData?.userProfile?.userId || 'NA',
      user_status: getUserStatus(),
      login_type: userData?.isLoggedIn ? 'logged-in' : 'logged-out',
      select_type: selectType,
      language_type: language,
      language_hit: 'english',
      Platform: isMobile ? 'mobile' : 'desktop',
      SiteName: 'www.ndtvprofit.com',
    };

    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push(baseData);
    } else {
      console.error('Error: window.dataLayer is not available');
    }
  };

  const SocialIcon = ({ type, showMenu }) => {
    if (!showMenu) return null;
    if (isMobile) {
      return <SvgIcon type={type} width="36px" height="36px" source="image" />;
    } else {
      return null;
    }
  };

  return (
    <>
      <div
        styleName={`megamenu-wrapper  ${isBeeps ? 'dark-megamenu' : ''} ${showMenu ? 'showMenu' : 'hide-menu'}`}
        id="sidemenu-wrap"
      >
        <div styleName={`megamenu-top-section ${isBeeps ? 'dark-top-section' : ''}`}>
          <div styleName="logo-section">
            <div>
              {!isBeeps ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="142.72"
                  height="24.539"
                  viewBox="0 0 142.72 24.539"
                  style={{ width: '168px', height: '29px' }}
                >
                  <defs>
                    <style>{`
                  .a{fill:url(#a);}
                  .b{fill:url(#b);}
                  .c{fill:url(#c);}
                  .d{fill:url(#d);}
                  .e{fill:url(#e);}
                  .f{fill:#fff;}
                  .g{fill:#ec1d24;}
                `}</style>
                    <linearGradient
                      id="a"
                      y1="0.5"
                      x2="3.942"
                      y2="0.5"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0.02" stop-color="#026ee0" />
                      <stop offset="0.08" stop-color="#0677e3" />
                      <stop offset="0.17" stop-color="#1190ec" />
                      <stop offset="0.29" stop-color="#24b9fb" />
                      <stop offset="0.3" stop-color="#26befd" />
                      <stop offset="0.35" stop-color="#3ab6fb" />
                      <stop offset="0.44" stop-color="#6ea2f8" />
                      <stop offset="0.57" stop-color="#c081f3" />
                      <stop offset="0.65" stop-color="#f76df0" />
                      <stop offset="0.92" stop-color="#f75ee3" />
                      <stop offset="0.97" stop-color="#dd5687" />
                    </linearGradient>
                    <linearGradient id="b" x1="-2.006" x2="4.859" xlinkHref="#a" />
                    <linearGradient id="c" x1="-1.965" x2="2.362" xlinkHref="#a" />
                    <linearGradient id="d" x1="-2.659" x2="1.186" xlinkHref="#a" />
                    <linearGradient id="e" x1="-6.62" x2="0.142" xlinkHref="#a" />
                  </defs>
                  <g transform="translate(78.009 1.844)">
                    <g transform="translate(0)">
                      <path
                        class="a"
                        d="M1406.672,51.47v6.281h-4.463V39.24h7.387a8.609,8.609,0,0,1,3.757.782,5.894,5.894,0,0,1,2.53,2.225,6.075,6.075,0,0,1,.9,3.273,5.357,5.357,0,0,1-1.939,4.329,8.045,8.045,0,0,1-5.321,1.621h-2.848Zm0-3.446h2.924a2.755,2.755,0,0,0,1.977-.649,2.409,2.409,0,0,0,.681-1.831,2.98,2.98,0,0,0-.7-2.073,2.478,2.478,0,0,0-1.907-.788h-2.974v5.34Z"
                        transform="translate(-1402.21 -37.956)"
                      />
                      <path
                        class="b"
                        d="M1621.1,99.852l-1.411-.1q-2.021,0-2.593,1.272v8.709h-4.285V95.974h4.018l.139,1.767a3.318,3.318,0,0,1,3.013-2.022,4.175,4.175,0,0,1,1.2.153l-.077,3.979Z"
                        transform="translate(-1596.029 -89.936)"
                      />
                      <path
                        class="c"
                        d="M1729.44,102.725a8.123,8.123,0,0,1,.8-3.668,5.729,5.729,0,0,1,2.3-2.473,6.931,6.931,0,0,1,3.521-.865,6.326,6.326,0,0,1,4.87,1.913,7.343,7.343,0,0,1,1.78,5.206v.153a7.122,7.122,0,0,1-1.786,5.1,7.169,7.169,0,0,1-9.554.127,6.89,6.89,0,0,1-1.92-4.774Zm4.284.267a5.116,5.116,0,0,0,.6,2.8,1.99,1.99,0,0,0,1.767.89q2.289,0,2.339-3.521v-.432q0-3.7-2.365-3.7-2.149,0-2.327,3.191l-.013.775Z"
                        transform="translate(-1703.365 -89.936)"
                      />
                      <path
                        class="d"
                        d="M1902.636,42.924V32.143h-2V29.168h2v-.457a5.252,5.252,0,0,1,1.806-4.208,7.212,7.212,0,0,1,4.691-1.373,16.673,16.673,0,0,1,4.475.737l-.585,3.382-.712-.19a11.344,11.344,0,0,0-2.924-.369q-2.454,0-2.453,2.238v.241h2.695v2.975h-2.695V42.924Zm12.942,0h-4.31V29.168h4.31Z"
                        transform="translate(-1860.923 -23.13)"
                      />
                      <path
                        class="e"
                        d="M2113.778,55.99v3.42h2.263v2.975h-2.263v6.293a1.6,1.6,0,0,0,.28,1.081,1.5,1.5,0,0,0,1.105.305,6.269,6.269,0,0,0,1.068-.076v3.064a7.916,7.916,0,0,1-2.416.369,4.489,4.489,0,0,1-3.267-1.042,4.275,4.275,0,0,1-1.054-3.166V62.385h-1.755V59.41h1.755V55.99h4.284Z"
                        transform="translate(-2051.521 -53.372)"
                      />
                    </g>
                  </g>
                  <g transform="translate(0 0)">
                    <g transform="translate(0 5.84)">
                      <path
                        d="M647.122,73.282h33.161c.016.029.034.058.049.088l4.955,9.373c.016.031.033.061.054.1.017-.033.03-.057.041-.08l3.678-7.385q.522-1.048,1.046-2.1h4.038c-.012.029-.022.058-.035.085q-3.2,6.347-6.39,12.694a.113.113,0,0,1-.119.071q-2.272,0-4.544,0a.131.131,0,0,1-.137-.082q-2.566-4.834-5.135-9.666a.116.116,0,0,0-.119-.074q-2.545,0-5.089,0h-.092v9.813h-3.754V76.318h-5.839c.006.027.01.047.015.066a7.758,7.758,0,0,1,.26,1.792c.015.6.021,1.21.014,1.816-.006.454-.022.909-.062,1.361a6.319,6.319,0,0,1-.5,1.969,4.333,4.333,0,0,1-2.211,2.3,6.025,6.025,0,0,1-2.319.509c-.112,0-.222.01-.334.015H647.124a.5.5,0,0,1-.014-.083v-12.7a.5.5,0,0,1,.014-.083Zm3.789,9.826h6.322a3.317,3.317,0,0,0,.841-.1,1.577,1.577,0,0,0,1.189-1.078,2.449,2.449,0,0,0,.115-.767c0-.967,0-1.933,0-2.9a2.537,2.537,0,0,0-.034-.418,1.669,1.669,0,0,0-1.04-1.339,2.754,2.754,0,0,0-1.089-.194h-6.22c-.027,0-.055,0-.083,0v6.791Z"
                        transform="translate(-629.271 -73.28)"
                      />
                      <path
                        d="M436.116,73.282h3.913V86.131h-4.068a4.753,4.753,0,0,1-2.259-.562,5.515,5.515,0,0,1-2.357-2.465c-.326-.643-.63-1.3-.945-1.946l-1.449-2.991a2.676,2.676,0,0,0-.4-.61,1.67,1.67,0,0,0-.8-.542,1.19,1.19,0,0,0-.448-.037v9.048c0,.038-.006.077-.008.116h-3.944c0-.033-.006-.067-.006-.1V73.381c0-.033,0-.067.006-.1h4.085l.076.009c.225.02.452.025.674.061a4.937,4.937,0,0,1,2.379,1.088,6.272,6.272,0,0,1,1.684,2.167c.693,1.44,1.376,2.885,2.061,4.328a4.477,4.477,0,0,0,.456.786,1.871,1.871,0,0,0,.768.641,1.2,1.2,0,0,0,.582.084V73.4c0-.041,0-.083,0-.124Z"
                        transform="translate(-423.331 -73.28)"
                      />
                      <path
                        class="f"
                        d="M423.247,73.3c0,.033-.006.067-.006.1V86.061c0,.033,0,.067.006.1-.006,0-.014,0-.015-.008,0-.021,0-.041,0-.062V73.37A.312.312,0,0,1,423.247,73.3Z"
                        transform="translate(-423.231 -73.298)"
                      />
                      <path
                        class="g"
                        d="M613.425,129.382h-.3c-.115-.018-.231-.031-.344-.056a2.35,2.35,0,0,1,1.027-4.587,2.375,2.375,0,0,1,1.8,2.671,2.312,2.312,0,0,1-1.824,1.911C613.671,129.347,613.548,129.362,613.425,129.382Z"
                        transform="translate(-595.989 -120.581)"
                      />
                    </g>
                    <path
                      d="M1308.666.77V23.75c-.005.028-.01.056-.014.084a.779.779,0,0,1-.555.665l-.1.031h-.592l-.124-.038a.8.8,0,0,1-.54-.79q.005-11.441,0-22.882c0-.026,0-.052,0-.078a.776.776,0,0,1,.536-.712l.124-.038H1308c.017.006.033.013.049.018a.754.754,0,0,1,.544.448,2.049,2.049,0,0,1,.078.315Z"
                      transform="translate(-1236.338 0.01)"
                    />
                  </g>
                </svg>
              ) : (
                <img
                  src="/images/NDTV-Profit-logo-darkmode.png"
                  alt="ndtv|Profit"
                  width="168px"
                  height="29px"
                />
              )}
            </div>
            <div styleName="language-toggle" className="desktop-only">
              <div styleName={`toggle-btn-container ${isBeeps ? 'dark-toggle-btn' : ''}`}>
                <button
                  styleName="toggle-btn toggle-selected"
                  onClick={() => handleLanguageClick('english', 'hamburger')}
                >
                  English
                </button>
                <BQLink
                  href="https://hindi.ndtvprofit.com?utm_source=profit&utm_medium=referral&utm_campaign=language"
                  target="_blank"
                  rel="noreferrer"
                >
                  <button
                    styleName="toggle-btn"
                    onClick={() => handleLanguageClick('hindi', 'hamburger')}
                  >
                    Hindi
                  </button>
                </BQLink>
              </div>
            </div>
            <div
              styleName={`close-icon ${isBeeps ? 'dark-close-icon' : ''}`}
              onClick={() => {
                setOpen(false);
                handleMenuClose();
              }}
            >
              <CloseIcon color="#5d6d77" />
            </div>
          </div>
          {LoginForm('desktop-only')}
        </div>

        {isLoading ? (
          <div styleName="greeting-skeleton">
            <div styleName="profile-skeleton" />
            <div styleName="name-skeleton">
              <div styleName="large-skeleton"></div>
              <div styleName="small-skeleton"></div>
            </div>
          </div>
        ) : (
          <>{LoginForm('mobile-only')}</>
        )}

        {isOpen && (
          <div styleName={isBeeps ? 'profile-list dark-profile-list' : 'profile-list'}>
            {mobileMenu?.map((dl) =>
              dl.name === 'My Subscription' ? null : (
                <div
                  styleName="list"
                  key={dl.id || dl.name}
                  onClick={() => accountInteraction(userData, pageType, 'hamburger', dl.name)}
                >
                  <Icon path={dl.icon} size="20px" color="#b7bfc4" />
                  <BQLink href={dl.link}>{dl.name}</BQLink>
                </div>
              ),
            )}
          </div>
        )}
        <div styleName={`megamenu-bottom-section ${isBeeps ? 'dark-bottom-section' : ''}`}>
          <div styleName="megamenu-left">
            <div styleName="menu-list">
              {showMenuBar && (
                <div
                  styleName="menu-item"
                  style={{ color: '#5c6d77' }}
                  onClick={() => (window.location.href = '/?src=top_nav')}
                  className="mobile-only"
                >
                  <div styleName="icon-wrapper">
                    <Icon path={mdiHome} size={'20px'} color="#B7BFC4" />
                  </div>
                  <div styleName={isBeeps ? 'dark-title' : ''}>Home</div>
                </div>
              )}
              {menu?.length > 0
                ? menu.slice(0, -1).map((item, index) => {
                    const icon = get(item, ['data', 'icon-code'], 'default');
                    const menuExpanded = currentOpenMenu === item.title;
                    return (
                      <React.Fragment key={index}>
                        <div
                          styleName="menu-item"
                          onClick={() => {
                            if (item.title === worldsummit.name) {
                              window.open(`${worldsummit?.link}${worldsummit?.utm}`, '_blank');
                            } else if (!item.children?.length) {
                              window.location.href = item.completeUrl + '?src=menu';
                            }
                            handleMenuExpand(item.title);
                            handleClickItem(item, formattedPageType);
                          }}
                          key={item?.id || index}
                          style={{ color: item?.data?.color ? item?.data?.color : '#5c6d77' }}
                        >
                          <div styleName="icon-wrapper">
                            {item.completeUrl === '/budget' ? (
                              <Icon path={mdiSackPercent} size={'20px'} color="#B7BFC4" />
                            ) : item.title.toLowerCase() === 'beeps' ? (
                              <img
                                src="/icons/beeps-icon.svg"
                                loading="lazy"
                                width="20px"
                                height="20px"
                              />
                            ) : item.completeUrl === '/premium' ? (
                              <Icon path={mdiStarFourPoints} size={'20px'} color="#CE9445" />
                            ) : item.title === worldsummit.name ? (
                              <Icon path={mdiWeb} size={'20px'} color="#B7BFC4" />
                            ) : (
                              <>
                                {Object.keys(menuIcons).includes(icon) !== true
                                  ? menuIcons.default
                                  : menuIcons[icon]}
                              </>
                            )}
                          </div>
                          <div styleName={isBeeps ? 'dark-title' : ''}>
                            {item.completeUrl === '/premium' ? (
                              <Premium fontSize={'18px'} />
                            ) : item.title.toLowerCase() === 'beeps' ? (
                              <img
                                src="/icons/beeps-title.svg"
                                style={{ marginBottom: '0px' }}
                                loading="lazy"
                                height="12px"
                              />
                            ) : item.completeUrl === '/budget' ? (
                              <img
                                src="/icons/budget-logo.svg"
                                style={{ marginBottom: '0px' }}
                                loading="lazy"
                                height="12px"
                              />
                            ) : item.title === worldsummit.name ? (
                              <img
                                src={worldsummit?.desk_img}
                                height={worldsummit?.desk_height}
                                width={worldsummit?.width}
                                alt={worldsummit?.name}
                              />
                            ) : (
                              item.title
                            )}
                          </div>
                          {item.completeUrl === '/the-latest' ? <div styleName="dot"></div> : null}
                          {item.title === 'Tools' ? <div styleName="new-badge">New</div> : null}
                          {item.children?.length > 0 ? (
                            <div
                              styleName="drop-down-icon"
                              style={{
                                transform: !menuExpanded ? 'rotate(0deg)' : 'rotate(-180deg)',
                              }}
                            >
                              <AngleDown fontSize="6px" />
                            </div>
                          ) : null}
                        </div>
                        <div
                          styleName={`nested-items ${
                            currentOpenMenu === item.title ? 'show-nested' : 'hide-nested'
                          } ${item.completeUrl === '/premium' ? 'show-nested-bg' : ''} ${isBeeps ? 'dark-bg' : ''}`}
                        >
                          {item.children.map((childItem, i) => (
                            <div
                              onClick={() => handleClickItem(childItem, formattedPageType)}
                              key={i}
                            >
                              <BQLink href={`${childItem.completeUrl}?src=menu` || '/'}>
                                {childItem.completeUrl === '/budget' ? (
                                  <img
                                    src="/icons/budget-logo.svg"
                                    style={{ marginBottom: '0px' }}
                                    loading="lazy"
                                    height="12px"
                                  />
                                ) : (
                                  childItem.title
                                )}
                              </BQLink>
                            </div>
                          ))}
                        </div>
                      </React.Fragment>
                    );
                  })
                : null}
            </div>
          </div>
          <div styleName={isBeeps ? 'megamenu-right dark-megamenu-right' : 'megamenu-right'}>
            <div
              styleName={isBeeps ? 'last-menu-item-section dark-section' : 'last-menu-item-section'}
            >
              {menu?.length > 0 ? (
                <>
                  <div styleName={`last-menu-item ${isBeeps ? 'dark-main' : ''}`}>
                    {menu[menu?.length - 1].title}
                  </div>
                  {menu[menu?.length - 1].children.map((item, index) => (
                    <div
                      styleName={`last-item-children ${isBeeps ? 'dark-child' : ''}`}
                      href={`${item.completeUrl}?src=menu` || '/'}
                      onClick={() => {
                        window.location.href = item.completeUrl + '?src=menu';
                        handleClickItem(item, formattedPageType);
                      }}
                      key={item?.id || index}
                    >
                      {item.title}
                    </div>
                  ))}
                </>
              ) : null}
            </div>
            <div
              styleName={
                isBeeps ? 'user-options-with-social dark-mb-bg' : 'user-options-with-social'
              }
            >
              <div styleName={`user-options-section ${isBeeps ? 'beeps-user-options' : ''}`}>
                <div>
                  <BQLink href={watchlistUrl} className="desktop-only">
                    <BinocularsIcon color={isBeeps ? '#b7bfc4' : '#8F9DA5'} size="24px" />
                    <span styleName={isBeeps ? 'title dark-title' : 'title'}>Watchlist</span>
                  </BQLink>
                </div>
                <div
                  onClick={() => accountInteraction(userData, pageType, 'hamburger', 'bookmarks')}
                >
                  <BQLink href={bookmarkUrl} className="desktop-only">
                    <BookmarkIcon color={isBeeps ? '#b7bfc4' : '#8F9DA5'} size="24px" />
                    <span styleName={isBeeps ? 'title dark-title' : 'title'}>Bookmarks</span>
                  </BQLink>
                </div>
                <div onClick={() => handleClickItem('Support', formattedPageType)}>
                  <BQLink href={`mailto:${CONTACT.SUPPORT_ID}`}>
                    <LifeBuoyIcon color={isBeeps ? '#b7bfc4' : '#8F9DA5'} size="24px" />
                    <span styleName={isBeeps ? 'title dark-title' : 'title'}>Support</span>
                  </BQLink>
                </div>
                <div onClick={() => handleClickItem('About NDTV Profit', formattedPageType)}>
                  <BQLink href="/about-us?src=menu">
                    <InformationOutlineIcon color={isBeeps ? '#b7bfc4' : '#8F9DA5'} size="24px" />
                    <span styleName={isBeeps ? 'title dark-title' : 'title'}>
                      About NDTV Profit
                    </span>
                  </BQLink>
                </div>
                {!!userDetails && !isBeeps && (
                  <span
                    styleName={
                      isBeeps
                        ? 'logout-button mobile-logout dark-logout'
                        : 'logout-button mobile-logout'
                    }
                    onClick={() => {
                      accountInteraction(userData, pageType, 'hamburger', 'logout');
                      onLogout();
                    }}
                    className="mobile-only"
                  >
                    <span>
                      <div styleName="icon">
                        <LogoutIcon color="border6-color" />
                      </div>
                      Logout
                    </span>
                  </span>
                )}
              </div>
              <div styleName="social-section" className="mobile-only">
                <div styleName="socials-title">FOLLOW NDTV Profit ON</div>
                <div styleName="social-icons-footer-menu">
                  <BQLink href={SOCIAL_SHARE.FACEBOOK} target="_blank">
                    <div
                      onClick={() =>
                        followIconsDl('facebook', formattedPageType, userData, 'hamburger')
                      }
                    >
                      <SocialIcon
                        type={isBeeps ? 'facebook_dark' : 'facebook_grey'}
                        showMenu={showMenu}
                      />
                    </div>
                  </BQLink>
                  <BQLink href={SOCIAL_SHARE.INSTAGRAM} target="_blank">
                    <div
                      onClick={() =>
                        followIconsDl('instagram', formattedPageType, userData, 'hamburger')
                      }
                    >
                      <SocialIcon
                        type={isBeeps ? 'instagram_dark' : 'instagram_grey'}
                        showMenu={showMenu}
                      />
                    </div>
                  </BQLink>
                  <BQLink href={SOCIAL_SHARE.LINKEDIN} target="_blank">
                    <div
                      onClick={() =>
                        followIconsDl('linkedin', formattedPageType, userData, 'hamburger')
                      }
                    >
                      <SocialIcon
                        type={isBeeps ? 'linkedin_dark' : 'linkedin_grey'}
                        showMenu={showMenu}
                      />
                    </div>
                  </BQLink>
                  <BQLink href={SOCIAL_SHARE.YOUTUBE} target="_blank">
                    <div
                      onClick={() =>
                        followIconsDl('youtube', formattedPageType, userData, 'hamburger')
                      }
                    >
                      <SocialIcon
                        type={isBeeps ? 'youtube_dark' : 'youtube_grey'}
                        showMenu={showMenu}
                      />
                    </div>
                  </BQLink>
                  <BQLink href={SOCIAL_SHARE.TWITTER} target="_blank">
                    <div
                      onClick={() =>
                        followIconsDl('twitter', formattedPageType, userData, 'hamburger')
                      }
                    >
                      <SocialIcon type={isBeeps ? 'x_dark' : 'x_grey'} showMenu={showMenu} />
                    </div>
                  </BQLink>
                  <BQLink href={SOCIAL_SHARE.TELEGRAM} target="_blank">
                    <div
                      onClick={() =>
                        followIconsDl('telegram', formattedPageType, userData, 'hamburger')
                      }
                    >
                      <SocialIcon
                        type={isBeeps ? 'telegram_dark' : 'telegram_grey'}
                        showMenu={showMenu}
                      />
                    </div>
                  </BQLink>
                </div>
              </div>
              <div styleName="app-promotion-section" className="mobile-only">
                <div styleName="download-app-title">DOWNLOAD THE APP</div>
                <div styleName="appstore-playstore-links">
                  <BQLink
                    href="https://play.google.com/store/apps/details?id=com.ndtv.ndtvprofit&pcampaignid=web_share"
                    target="_blank "
                    rel="noopener noreferrer nofollow"
                  >
                    <div
                      onClick={() =>
                        downloadAppDl('play store', userData, formattedPageType, 'hamburger menu')
                      }
                    >
                      <SvgIcon
                        type="playstore"
                        width="100%"
                        height="42px"
                        source="image"
                        isSvg={false}
                        loading="lazy"
                        iconStyle={{
                          width: 'auto',
                          height: 'auto',
                          maxHeight: '100%',
                          maxWidth: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                  </BQLink>
                  <BQLink
                    href="https://apps.apple.com/in/app/ndtv-profit/id502359431"
                    target="_blank "
                    rel="noopener noreferrer nofollow"
                  >
                    <div
                      onClick={() =>
                        downloadAppDl('app store', userData, formattedPageType, 'hamburger menu')
                      }
                    >
                      <SvgIcon
                        type="appstore"
                        width="100%"
                        height="42px"
                        source="image"
                        isSvg={false}
                        loading="lazy"
                        iconStyle={{
                          width: 'auto',
                          height: 'auto',
                          maxHeight: '100%',
                          maxWidth: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                  </BQLink>
                </div>
                <div styleName={isBeeps ? 'app-version dark-version' : 'app-version'}>
                  <CellPhoneIcon color={'var(--fourth-color)'} size="18px" />
                  <span>v1.0.1</span>
                </div>
                <div styleName={isBeeps ? 'app-message dark-message' : 'app-message'}>
                  Made with <HeartIcon color="var(--submarine)" size="18px" />
                  by Business Experts
                </div>
              </div>
            </div>
          </div>
          <div
            styleName={
              isBeeps ? 'language-toggle-with-live-tv dark-toggle' : 'language-toggle-with-live-tv'
            }
            className="mobile-only"
          >
            <div
              onClick={() => languageSelection(formattedPageType, userData, 'hamburger')}
              styleName="toggles"
            >
              {/* <BQLink
                styleName="language-toggle-hindi"
                href="https://hindi.ndtvprofit.com?utm_source=profit&utm_medium=referral&utm_campaign=language"
                target="_blank"
                rel="noreferrer"
              >
                Switch to हिंदी
              </BQLink> */}
              <div onClick={() => clickPreferredSourceBadge()}>
                <BQLink
                  href={googleBadge?.link}
                  target={googleBadge?.target || '_self'}
                  rel="noreferrer"
                >
                  {showMenu && isMobile && (
                    <img
                      src={googleBadge?.darkBadge}
                      alt="Google Badge"
                      height="38px"
                      width="auto"
                    />
                  )}
                </BQLink>
              </div>
            </div>
            <div
              onClick={() => watchLiveInteraction(userData, formattedPageType, 'hamburger')}
              styleName="toggles"
            >
              <BQLink href="/live-tv?src=menu_livetv" styleName="live-tv-sidebar-footer">
                <TelevisionClassicIcon color="#ffff" size="19px" />
                <span styleName="text">LIVE TV</span>
              </BQLink>
            </div>
          </div>
        </div>
        {!isMobile && (
          <div
            styleName={`app-scan ${showMenu ? 'show-app-scan' : ''} ${isBeeps ? 'dark-view' : ''}`}
          >
            <div styleName="app-scan-details">
              <div styleName="download-text">Download NDTV Profit</div>
              <div styleName="download-sub-text">Scan to download the app</div>
              <BQLink
                href="https://play.google.com/store/apps/details?id=com.ndtv.ndtvprofit&pcampaignid=web_share"
                target="_blank "
                rel="noopener noreferrer nofollow"
              >
                <div
                  onClick={() =>
                    downloadAppDl('play store', userData, formattedPageType, 'hamburger menu')
                  }
                >
                  <SvgIcon
                    type="playstore"
                    width="115px"
                    height="40px"
                    source="image"
                    isSvg={false}
                    loading="lazy"
                  />
                </div>
              </BQLink>
              <BQLink
                href="https://apps.apple.com/in/app/ndtv-profit/id502359431"
                target="_blank "
                rel="noopener noreferrer nofollow"
              >
                <div
                  onClick={() =>
                    downloadAppDl('app store', userData, formattedPageType, 'hamburger menu')
                  }
                >
                  <SvgIcon
                    type="appstore"
                    width="115px"
                    height="40px"
                    source="image"
                    isSvg={false}
                    loading="lazy"
                  />
                </div>
              </BQLink>
            </div>

            <SvgIcon
              type="app-download-scanner"
              width="172px"
              height="191px"
              source="image"
              isSvg={false}
              loading="lazy"
            />
            <div onClick={() => clickPreferredSourceBadge()}>
              <BQLink
                styleName="google-play-section"
                href={googleBadge?.link}
                target={googleBadge?.target || '_self'}
              >
                <div styleName="content">
                  <div>{googleBadge?.title}</div>
                  <div styleName="sub-title">{googleBadge?.subTitle}</div>
                </div>
                {showMenu && !isMobile && (
                  <img
                    src={googleBadge?.lightBadge}
                    alt="Google Badge"
                    height="48px"
                    width="151px"
                  />
                )}
              </BQLink>
            </div>
          </div>
        )}
      </div>
      {isHomePage && showApp && (
        <BQLink
          href={appDownloadLink}
          target="_blank"
          styleName={`app-download-side-stick ${isCollapsed ? 'shrink-app-download' : ''} ${isPodcast ? 'app-up' : ''}`}
          className="mobile-only"
        >
          <CellphoneDownloadIcon size="18px" color="#fff" />
          <span style={{ color: isCollapsed ? '#3A71F5' : '#FFF' }}>GET APP</span>
        </BQLink>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  integrations: state.qt.config['integrations'],
  clientHost: get(
    state,
    ['qt', 'config', 'publisher', 'client_host'],
    'https://www.ndtvprofit.com',
  ),
});

export default connect(mapStateToProps)(MegaMenu);
